import './style.css.js';
import '@magnetic/theme';
import { withSubComponent } from '@magnetic/higher-order-components';
import React, { forwardRef } from 'react';
import { InputAutocomplete } from './input-autocomplete/index.js';
import { InputFrame } from './input-frame.js';
import { InputFunctionalButton } from './input-functional-button.js';
import { InputNumber } from './input-number.js';
import { InputPassword } from './input-password.js';
import { InputWithAnalytics } from './input-with-analytics.js';

const Input = withSubComponent(
  forwardRef(
    ({
      className,
      disabled,
      fixedWidth,
      invalid = false,
      label,
      onClear,
      optional,
      prefix,
      required = false,
      size = "md",
      suffix,
      tooltip,
      value,
      ...rest
    }, ref) => /* @__PURE__ */ React.createElement(InputFrame, {
      className,
      disabled,
      fixedWidth,
      hasValue: !!value,
      invalid,
      label,
      onClear,
      optional,
      prefix,
      required,
      size,
      suffix,
      tooltip
    }, /* @__PURE__ */ React.createElement(InputWithAnalytics, {
      ...rest,
      "aria-invalid": invalid,
      disabled,
      label,
      ref,
      required,
      type: "string",
      value
    }))
  ),
  {
    FunctionalButton: InputFunctionalButton,
    Number: InputNumber,
    Password: InputPassword,
    Autocomplete: InputAutocomplete
  }
);

export { Input };
//# sourceMappingURL=index.js.map
